export default __webpack_public_path__ + "EligibleProduct2_CA.ae38b54f.png";